// constants
import { AuthActionTypes } from "./constants";

export interface AuthActionType {
  type:
    | AuthActionTypes.API_RESPONSE_SUCCESS
    | AuthActionTypes.API_RESPONSE_ERROR
    | AuthActionTypes.FORGOT_PASSWORD
    | AuthActionTypes.FORGOT_PASSWORD_CHANGE
    | AuthActionTypes.LOGIN_USER
    | AuthActionTypes.LOGOUT_USER
    | AuthActionTypes.RESET
    | AuthActionTypes.SIGNUP_USER
    | AuthActionTypes.setUser
    | AuthActionTypes.LOGIN_STUDENT_USER; 
  payload: {} | string;
}

interface UserData {
  id: number;
  email: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
  token: string;
  enrollment_no?:string;
  punchingid?:string;
}

// common success
export const authApiResponseSuccess = (
  actionType: string,
  data: UserData | {}
): AuthActionType => ({
  type: AuthActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
}

);
//  set parentId
export const setParentId = (parentId: string) => ({
  type: 'SET_PARENT_ID',
  payload: parentId,
});



// common error
export const authApiResponseError = (
  actionType: string,
  error: string
): AuthActionType => ({
  type: AuthActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});



export const loginUser = (email: string, password: string, punchingid : string): AuthActionType => ({
  type: AuthActionTypes.LOGIN_USER,
  payload: { email, password, punchingid },
});

export const setUser = (user:[]) => ({
  type: AuthActionTypes.setUser,
  payload: user,  
});


export const logoutUser = (): AuthActionType => ({
  type: AuthActionTypes.LOGOUT_USER,
  payload: {},
});

export const signupUser = (
  fullname: string,
  email: string,
  password: string
): AuthActionType => ({
  type: AuthActionTypes.SIGNUP_USER,
  payload: { fullname, email, password },
});

export const forgotPassword = (email: string): AuthActionType => ({
  type: AuthActionTypes.FORGOT_PASSWORD,
  payload: { email },
});

export const resetAuth = (): AuthActionType => ({
  type: AuthActionTypes.RESET,
  payload: {},
});

// Student Login User
export const loginStudentUser = (email: string, password: string, enrollment_no:string): AuthActionType => ({
  type: AuthActionTypes.LOGIN_STUDENT_USER,
  payload: { email, password, enrollment_no },
});